import axios from 'axios';
import { BACKEND_URL } from '../config/api';

// Canonical Platform Admin tabs (mirrors backend RBAC tab ids)
export const SUPER_ADMIN_TABS = [
  { id: 'dashboard', label: 'Overview' },
  { id: 'accounts', label: 'Accounts' },
  { id: 'bookings', label: 'Bookings' },
  { id: 'tickets', label: 'Tickets' },
  { id: 'team', label: 'Team' },
  { id: 'roles', label: 'Roles' },
  { id: 'reports', label: 'Reports' },
  { id: 'onboarding', label: 'Onboarding' },
  { id: 'demo', label: 'Demo' },
  { id: 'ecosystem', label: 'Ecosystem' },
  { id: 'referrals', label: 'Referrals' },
  { id: 'ops', label: 'Ops & Tools' },
  { id: 'metrics', label: 'Mission Control' },
  { id: 'activity', label: 'Activity' },
  { id: 'daily-tests', label: 'Daily Tests' },
];

// Fire-and-forget audit event (tab navigation, exports, logout, ...)
export const logAdminEvent = (action, details = {}) => {
  const token = localStorage.getItem('jwtToken');
  if (!token) return;
  axios.post(
    `${BACKEND_URL}/api/v2/super-admin/log-event`,
    { action, details },
    { headers: { Authorization: `Bearer ${token}` } }
  ).catch(() => {});
};

export const getAdminUserData = () => {
  try {
    return JSON.parse(localStorage.getItem('userData') || '{}');
  } catch {
    return {};
  }
};

// Tab visibility: owners see everything; others need read permission
export const canReadTab = (userData, tabId) => {
  if (userData?.is_owner_role) return true;
  return !!userData?.tab_permissions?.[tabId]?.read;
};

export const canManageTab = (userData, tabId) => {
  if (userData?.is_owner_role) return true;
  return !!userData?.tab_permissions?.[tabId]?.manage;
};

// "2026-07-12" → "July 12th, 2026" (human-friendly, works for USA & UAE)
export const formatTripDate = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(String(dateStr).slice(0, 10) + 'T00:00:00');
  if (isNaN(d.getTime())) return dateStr;
  const day = d.getDate();
  const suffix = [11, 12, 13].includes(day % 100) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
  return `${d.toLocaleDateString('en-US', { month: 'long' })} ${day}${suffix}, ${d.getFullYear()}`;
};

// "2026-07-12" → "Jul 12, 2026" (compact — PDFs, tight columns)
export const formatTripDateShort = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(String(dateStr).slice(0, 10) + 'T00:00:00');
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
